import { render, staticRenderFns } from "./PartnerPriceList.vue?vue&type=template&id=5bdc037c&"
import script from "./PartnerPriceList.vue?vue&type=script&lang=js&"
export * from "./PartnerPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports